import { ContentConfig } from './types';

export const defaultContent: ContentConfig = {
  header: {
    title: 'Nigerian Institute of Food Science & Technology',
    subtitle: 'Membership Registration Form'
  },
  steps: {
    category: { title: 'I - Membership Category', subtitle: 'Select one category' },
    appType: { title: 'II - Application Type', subtitle: 'Select application nature' },
    personal: { title: 'III - Personal Data', subtitle: 'Personal Details' },
    contact: { title: 'IV - Contact Details', subtitle: 'Contact Information' },
    academic: { title: 'V - University Degrees / Diplomas', subtitle: 'Academic Qualifications' },
    student: { title: 'VI - Student Particulars', subtitle: 'For Student Members Only' },
    employment: { title: 'VII - Employment Record', subtitle: 'Employment History' },
    affiliations: { title: 'VIII - Affiliations', subtitle: 'Membership of Professional Bodies' },
    career: { title: 'IX - Career Summary', subtitle: 'Summary of Career' },
    referees: { title: 'X - Referees', subtitle: 'Referees' },
    chapter: { title: 'XII - Chapter Info', subtitle: 'Chapter Registration' },
    declaration: { title: 'XIV - Declaration & Submission', subtitle: '' },
    payment: { title: 'Application Fee', subtitle: 'Pay your application processing fee' },
    fellowUploads: { title: 'Fellow Application', subtitle: 'Supporting Documents' }
  },
  labels: {
    surname: 'Surname',
    firstName: 'First Name',
    otherNames: 'Other Names',
    dob: 'Date of Birth',
    sex: 'Sex',
    maritalStatus: 'Marital Status',
    passportPhoto: 'Passport Photograph',
    officeAddress: 'Office Address',
    officeTelephone: 'Office Telephone',
    officeEmail: 'Office Email',
    homeAddress: 'Permanent Home Address',
    postalAddress: 'Postal Address',
    mobileTelephone: 'Mobile Telephone',
    homeEmail: 'Home Email',
    degrees: 'Degrees & Diplomas',
    studentCourse: 'Course of Study',
    studentInstitution: 'Institution',
    studentCommenced: 'Commenced',
    studentCompletion: 'Expected Completion',
    studentMode: 'Mode of Study',
    employmentHistory: 'Employment History',
    professionalBodies: 'Professional Bodies',
    careerSummary: 'Career Summary (Experience & Contributions)',
    referee1Name: 'Name',
    referee1Id: 'Membership ID',
    referee2Name: 'Name',
    referee2Id: 'Membership ID',
    chapterName: 'Chapter Name',
    chapterChairman: 'Chairman Name',
    amountEnclosed: 'Amount Enclosed',
    applicantSignature: 'Signature of Applicant',
    fellowCitation: 'Citation (maximum 500 words)',
    fellowStatement: 'Statement of Activities (maximum 100 words)'
  },
  wizardSteps: [
    "Category",
    "Personal",
    "Contact",
    "Academic",
    "Professional",
    "Employment",
    "Affiliations",
    "Career",
    "References",
    "Chapter",
    "Declaration",
    "Payment",
    "Fellow Uploads"
  ],
  declaration: "I confirm the above declaration"
};
